<template>
  <transition appear name="fade">
    <div class="col-md-9 p-4">
      <h4>Customers</h4>
      <hr />
      <button class="btn btn-primary" @click="addCustomer()">
        Add Customer
      </button>
      <div class="customerFilters">
        <div>
          <label>Page Size:</label>
          <a-select
            :value="pageSize"
            @change="(value) => updateForm('pageSize', value)"
          >
            <a-select-option :value="10">
              10
            </a-select-option>
            <a-select-option :value="25">
              25
            </a-select-option>
            <a-select-option :value="50">
              50
            </a-select-option>
            <a-select-option :value="100">
              100
            </a-select-option>
          </a-select>
        </div>
        <div>
          <label>Search Term:</label>
          <a-input
            :value="searchTerm"
            @change="(e) => updateForm('searchTerm', e.target.value)"
          />
        </div>
      </div>
      <a-table
        :columns="CustomerFields"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        bordered
        :row-key="(record) => record.customerid"
      >
        <template slot="edit" scope="text,record">
          <button class="btn btn-primary" @click="editCustomer(record)">
            Edit
          </button>
        </template>
        <template slot="delete" scope="text,record">
          <button class="btn btn-danger" @click="deleteCustomer(record)">
            Delete
          </button>
        </template>
      </a-table>
      <edit-customer
        :resetTable="resetTable"
        v-if="OpenModal === 'editCustomer'"
      />
      <add-customer
        :resetTable="resetTable"
        v-if="OpenModal === 'addCustomer'"
      />
    </div>
  </transition>
</template>
<script>
import EditCustomer from "./EditCustomer.vue";
import AddCustomer from "./AddCustomer.vue";
import { mapState } from "vuex";
export default {
  name: "CustomersList",
  components: { EditCustomer, AddCustomer },
  data() {
    return {
      data: [],
      pagination: {
        showTotal: (total, range) => (
          <div>
            <div>
              {range[0]}-{range[1]} of {total} items
            </div>
            <li class="pagination-item" title="First Page">
              <button
                type="button"
                class="btn btn-primary"
                disabled={this.pagination.current === 1}
                onClick={() => this.goToPage(1)}
              >
                <font-awesome-icon icon="angle-double-left" class="m-0" />
              </button>
            </li>
          </div>
        ),
        itemRender: (current, type, originalElement) => {
          const goToNextPage = () => this.goToPage(this.pagination.current + 1);
          const totalPages = Math.ceil(
            this.pagination.total / this.pagination.pageSize
          );
          if (type === "next") {
            return (
              <div class="next-buttons" onClick={(e) => e.stopPropagation()}>
                <li class="pagination-item">
                  <button
                    type="button"
                    class="btn btn-primary"
                    disabled={totalPages === this.pagination.current}
                    onClick={goToNextPage}
                  >
                    <font-awesome-icon icon="angle-right" class="m-0" />
                  </button>
                </li>
                <li class="pagination-item" title="Last Page">
                  <button
                    type="button"
                    class="btn btn-primary"
                    disabled={totalPages === this.pagination.current}
                    onClick={() => this.goToPage(totalPages)}
                  >
                    <font-awesome-icon icon="angle-double-right" class="m-0" />
                  </button>
                </li>
              </div>
            );
          }
          return originalElement;
        },
        hideOnSinglePage: true,
      },
      pageSize: 10,
      loading: false,
      searchTerm: "",
      CustomerFields: [
        {
          title: "Customer Name",
          key: "customername",
          dataIndex: "customername",
          sorter: true,
        },
        {
          title: "",
          key: "edit",
          scopedSlots: { customRender: "edit" },
        },
        {
          title: "",
          key: "delete",
          scopedSlots: { customRender: "delete" },
        },
      ],
      sorter: {},
      sortField: "",
      sortOrder: "",
    };
  },
  methods: {
    goToPage(page) {
      const pager = { ...this.pagination };
      pager.current = page;
      this.pagination = pager;
      this.getCustomersData({
        pageSize: this.pagination.pageSize,
        current: page,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.sorter = { ...sorter };
      this.getCustomersData({
        current: pagination.current,
        sortField: sorter.field ?? "",
        sortOrder:
          sorter.order === "ascend"
            ? "ASC"
            : sorter.order === "descend"
            ? "DESC"
            : "",
      });
    },
    getCustomersData(params) {
      this.loading = true;
      this.$store
        .dispatch("customers/getCustomers", {
          ...params,
          searchTerm: this.searchTerm,
          pageSize: this.pageSize,
        })
        .then((data) => {
          const pagination = { ...this.pagination };
          pagination.total = data.totalRecords;
          pagination.pageSize = data.pageSize;
          this.loading = false;
          this.data = data.Result;
          this.pagination = pagination;
        });
    },
    updateForm(propertName, propertValue) {
      this[propertName] = propertValue;
      this.resetTable();
    },
    resetTable() {
      const pagination = { ...this.pagination };
      pagination.current = 1;
      this.pagination = pagination;
      this.getCustomersData({
        current: pagination.current,
        sortField: this.sorter.field ?? "",
        sortOrder:
          this.sorter.order === "ascend"
            ? "ASC"
            : this.sorter.order === "descend"
            ? "DESC"
            : "",
      });
    },
    editCustomer(customer) {
      this.$store.dispatch("customers/setCustomer", customer);
      this.$store.dispatch("customers/updateOpenModal", "editCustomer");
    },
    addCustomer() {
      this.$store.dispatch("customers/updateOpenModal", "addCustomer");
    },
    deleteCustomer(customer) {
      this.$confirm({
        title: "Delete Customer",
        content:
          "This customer will be permanently deleted and cannot be recovered. Are you sure?",
        okText: "Accept",
        okType: "danger",
        cancelText: "Go Back",
        onOk: () => {
          this.$store
            .dispatch("customers/deleteCustomer", {
              customerId: customer.customerid,
            })
            .then(() => {
              this.resetTable();
            });
        },
      });
    },
  },
  created() {
    this.getCustomersData({
      current: 1,
      sortField: "",
      sortOrder: "",
      pageSize: this.pageSize,
    });
    this.$store.dispatch("customers/getClients");
  },
  computed: {
    ...mapState({
      Status: (state) => state.customers.Status,
      OpenModal: (state) => state.customers.OpenModal,
    }),
  },
};
</script>
<style lang="scss">
@mixin form-field {
  background-color: #f0f9ff !important;
  height: calc(1.5em + 1rem);
  border-radius: 0.4rem;
  border: 0 solid #ced4da !important;
  box-shadow: inset 1px 1px 3px rgb(157 193 216 / 50%);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.customerFilters {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: max(2%, 10px);
  justify-content: space-between;
  margin-top: 2%;
  & > div {
    flex-basis: 40%;
    min-width: 100px;
    display: inline-block;
    label {
      margin-right: 2em;
    }
    .ant-select,
    & > .ant-input {
      width: 50%;
      min-width: 20px;
    }
    .ant-select-selection.ant-select-selection--single,
    & > .ant-input {
      @include form-field();
      .ant-select-selection__rendered {
        line-height: 36px;
      }
    }
  }
  & > div:nth-child(2) {
    text-align: right;
  }
}
</style>
<style scoped>
button.btn.btn-danger {
  color: white;
}
</style>
